import { type QueryHookOptions, useQuery } from "@apollo/client";
import { PostsListQuery } from "../graphql/queries";
import type { PostsListQueryType } from "@/types/graphql/partner.generated";

export const usePostsQuery = (
  options?: QueryHookOptions<PostsListQueryType>
) => {
  return useQuery<PostsListQueryType>(PostsListQuery, options);
};
